module.exports = __webpack_public_path__ + "static/media/ic_linkedin.dcb42467.svg";